"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var BidActions = require("@caddigital/sok-reducers/lib/actions/bid");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var Types = require("types");
var mapDispatchToProps = function (dispatch) { return ({
    openCopyFromProjectOverlay: function () {
        return dispatch(BidActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.COPY));
    },
    openImportFromProjectOverlay: function () {
        return dispatch(FilesActions.ImportFromProjectActions.copyFilesToggleOverlay('IMPORT'));
    },
    openNotifications: function (files, projectName) {
        dispatch(FilesActions.openNotificationsOptionsPaneAction(files, projectName));
    },
    openOverlay: function (mode, item) { return dispatch(FilesActions.PropertiesActions.openOverlay(mode, item)); },
    openNewFolderDialog: function () {
        return dispatch(FilesActions.PropertiesActions.openOverlay('NEW_FOLDER'));
    },
    openScheduledDeletionDialog: function (folder) {
        dispatch(FilesActions.PropertiesActions.openOverlay('TTL'));
        dispatch(FilesActions.PropertiesActions.getTTLRequest(folder));
    },
    closeDialog: function () {
        return dispatch(FilesActions.PropertiesActions.openOverlay('CLOSED'));
    },
    toggleFileReportModal: function () {
        dispatch(FilesActions.toggleFileReportModal());
    },
    deleteFiles: function (items) {
        dispatch(FilesActions.PropertiesActions.openOverlay('DELETE'));
        dispatch(FilesActions.PropertiesActions.deleteRequest(items));
    },
    setTTL: function (folderUuid, ttl) {
        dispatch(FilesActions.PropertiesActions.setTTLRequest(folderUuid, ttl));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
